import Service from '@ember/service';
import classic from 'ember-classic-decorator';

const OUTGOING_MESSAGE_SCOPE = 'client-portal-iframe-to-origin';

@classic
export default class IframeService extends Service {
  #heightInterval = null;
  #resizeHandler = null;
  #lastHeight = null;

  startHeightBroadcast() {
    if (typeof document === 'undefined' || this.#heightInterval) {
      return;
    }

    this.#lastHeight = this._getHeight();
    this._broadcastHeight(this.#lastHeight);

    this.#resizeHandler = () => this.#broadcastIfChanged();
    window.addEventListener('resize', this.#resizeHandler);
    this.#heightInterval = setInterval(() => this.#broadcastIfChanged(), 1000);
  }

  #broadcastIfChanged() {
    let height = this._getHeight();
    if (this.#lastHeight !== height) {
      this.#lastHeight = height;
      this._broadcastHeight(height);
    }
  }

  willDestroy() {
    super.willDestroy(...arguments);

    if (this.#heightInterval) {
      clearInterval(this.#heightInterval);
      this.#heightInterval = null;
    }

    if (this.#resizeHandler) {
      window.removeEventListener('resize', this.#resizeHandler);
      this.#resizeHandler = null;
    }
  }

  scrollTop(top) {
    this._postMessage({ action: 'scrollTop', top });
  }

  close() {
    this._postMessage({ action: 'close' });
  }

  appointmentRequested(params) {
    this._postMessage({ action: 'appointmentRequested', params });
  }

  contactFormSubmitted(params) {
    this._postMessage({ action: 'contactFormSubmitted', params });
  }

  _getHeight() {
    let rect = document.body.getBoundingClientRect();
    return rect.top + window.scrollY + rect.bottom;
  }

  _broadcastHeight(height) {
    this._postMessage({ action: 'height', height });
  }

  _postMessage(data) {
    if (!window.parent) {
      return;
    }

    data.scope = OUTGOING_MESSAGE_SCOPE;
    window.parent.postMessage(data, '*');
  }
}
